import { Colors } from '../../consts/Colors';
import Obstacle from '../Obstacle';
import { Scales } from '../../consts/Scales';

export default class Poisson2 extends Obstacle {
    constructor(scene, x, y, params = { showHitbox: false }) {
        super(scene, x, y, params);

        this.scene = scene;
        this.type = 'poisson2';
        this.speed = 300;
        this.setPosition(x, y);
        scene.add.existing(this);
    }

    addBody(params) {
        this.texture = this.scene.add.sprite(0, 0, 'poisson2').setOrigin(0.5);
        this.texture.anims.play('poissonAnim2');
        this.add(this.texture);
    }
}
